import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from '@ui/shared/feature-config';
import { AppComponent } from './app/app.component';
import { SportMapMapDataService } from './app/services/sport-map-map-data.service';
import { SearchFilterConfigService } from './app/services/filter/search-filter-config.service';
import { TargetGroupSelectFilterConfigService } from './app/services/filter/target-group-select-filter-config.service';
import { SportsSelectFilterConfigService } from './app/services/filter/sports-select-filter-config.service';
import { AccessibilitySelectFilterConfigService } from './app/services/filter/accessibility-select-filter-config.service';
import { TypeSelectFilterConfigService } from './app/services/filter/type-select-filter-config.service';
import { SportsClubMapDataService } from './app/services/data/sports-club-map-data.service';
import { SportsFacilityMapDataService } from './app/services/data/sports-facility-map-data.service';
import { PublicSportsFacilityMapDataService } from './app/services/data/public-sports-facility-map-data.service';

bootstrapApplication(AppComponent, createAppConfig({
    mapDataStateService: SportMapMapDataService,
    filterItems: [
        SearchFilterConfigService,
        TargetGroupSelectFilterConfigService,
        SportsSelectFilterConfigService,
        AccessibilitySelectFilterConfigService,
        TypeSelectFilterConfigService,
    ],
    dataEndpoints: [
        SportsClubMapDataService,
        SportsFacilityMapDataService,
        PublicSportsFacilityMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
